import { useCookies } from 'react-cookie'
import { CIAM_COOKIE_JWT, GIGYA_COOKIE_JWT } from '../utils/constants'

/**
 * Returns available auth JWT token.
 * Prefers CIAM token, falls back to Gigya token.
 */
export const useAuthToken = (): string | undefined => {
  const [cookies] = useCookies([CIAM_COOKIE_JWT, GIGYA_COOKIE_JWT])
  return cookies?.[CIAM_COOKIE_JWT] || cookies?.[GIGYA_COOKIE_JWT] || undefined
}
